<a class="text-primary hover:text-primary-hover cursor-pointer"><ng-content></ng-content></a>
